import React from 'react';
import { SUPPORTED_EXTENSION_GROUPS } from '../utils/supportedExtensions';

export default function PuziakBlock({ blockedFiles, onClose }) {
  const supportedFormats = SUPPORTED_EXTENSION_GROUPS.map((group) => (
    `${group.label} (${group.exts.join(', ')})`
  ));

  // Get unique file extensions from blocked files
  const blockedExtensions = [...new Set(blockedFiles.map(f => {
    const ext = f.name.split('.').pop().toLowerCase();
    return ext;
  }))];

  return (
    <div className="puziak-block-overlay">
      <div className="puziak-block-modal">
        <button className="puziak-close" onClick={onClose}>×</button>
        
        <div className="puziak-header">
          <h2>🚫 PUZIAK BLOCK</h2>
        </div>

        <div className="puziak-image">
          <img src="/puziak-block.png" alt="PUZIAK Block" />
        </div>

        <div className="puziak-quote">
          "I'm not mad, I'm just disappointed."
        </div>

        <div className="puziak-message">
          <p className="puziak-error">
            We do not allow <strong>{blockedExtensions.map(ext => `.${ext}`).join(', ')}</strong> files to be uploaded.
          </p>
          
          <p className="puziak-instruction">
            Please choose from these supported formats:
          </p>

          <ul className="puziak-formats">
            {supportedFormats.map((format, idx) => (
              <li key={idx}>{format}</li>
            ))}
          </ul>
        </div>

        <button className="puziak-ok-button" onClick={onClose}>
          I Understand
        </button>
      </div>

      <style>{`
        .puziak-block-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10000;
          animation: puziakFadeIn 0.2s ease;
        }

        @keyframes puziakFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .puziak-block-modal {
          background: white;
          border-radius: 12px;
          padding: 2rem;
          max-width: 500px;
          width: 90%;
          max-height: 90vh;
          overflow-y: auto;
          position: relative;
          animation: puziakSlideIn 0.3s ease;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        }

        @keyframes puziakSlideIn {
          from {
            transform: translateY(-20px) scale(0.95);
            opacity: 0;
          }
          to {
            transform: translateY(0) scale(1);
            opacity: 1;
          }
        }

        .puziak-close {
          position: absolute;
          top: 1rem;
          right: 1rem;
          background: none;
          border: none;
          font-size: 2rem;
          cursor: pointer;
          color: #666;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          transition: all 0.2s ease;
        }

        .puziak-close:hover {
          background: #f0f0f0;
          color: #000;
        }

        .puziak-header {
          text-align: center;
          margin-bottom: 1.5rem;
        }

        .puziak-header h2 {
          color: #d32f2f;
          font-size: 1.8rem;
          font-weight: 700;
          margin: 0;
          letter-spacing: 2px;
        }

        .puziak-image {
          text-align: center;
          margin: 1.5rem 0;
        }

        .puziak-image img {
          max-width: 200px;
          height: auto;
        }

        .puziak-quote {
          text-align: center;
          font-style: italic;
          color: #666;
          font-size: 1.1rem;
          margin: 1rem 0 1.5rem;
          font-family: Georgia, serif;
        }

        .puziak-message {
          text-align: center;
        }

        .puziak-error {
          color: #d32f2f;
          font-size: 1.1rem;
          margin: 1rem 0;
        }

        .puziak-error strong {
          background: #ffebee;
          padding: 2px 6px;
          border-radius: 4px;
          font-family: monospace;
          color: #c62828;
        }

        .puziak-instruction {
          color: #333;
          font-size: 1rem;
          margin: 1.5rem 0 1rem;
        }

        .puziak-formats {
          list-style: none;
          padding: 0;
          margin: 1rem 0 2rem;
          text-align: left;
          background: #f5f5f5;
          border-radius: 8px;
          padding: 1rem;
        }

        .puziak-formats li {
          padding: 0.5rem 0;
          border-bottom: 1px solid #e0e0e0;
          color: #555;
          font-size: 0.95rem;
        }

        .puziak-formats li:last-child {
          border-bottom: none;
        }

        .puziak-formats li:before {
          content: "✓";
          color: #4caf50;
          margin-right: 0.5rem;
          font-weight: bold;
        }

        .puziak-ok-button {
          width: 100%;
          padding: 0.75rem;
          background: #3e5c58;
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.2s ease;
        }

        .puziak-ok-button:hover {
          background: #304849;
        }

        @media (max-width: 640px) {
          .puziak-block-modal {
            padding: 1.5rem;
            width: 95%;
          }

          .puziak-header h2 {
            font-size: 1.5rem;
          }

          .puziak-image img {
            max-width: 150px;
          }
        }
      `}</style>
    </div>
  );
}
